<template>
  <div class="maintenance-other-recommend">
    <section v-if="loadData && datalist.length != 0">
      <div class="main">
        <section class="recommend" v-if="datalist.type == 'engineOil'">
          <div class>
            <header class="flex">
              <div class="title font-14">机油推荐</div>
              <div
                class="type font-12 color-gray9"
                v-if="datalist.data[0].data.filling"
              >
                机油加注量:
                <span v-text="datalist.data[0].data.filling || '--' + 'L'"
                  >3L</span
                >
              </div>
            </header>
            <div class="content flex" v-if="datalist.data[0].data.lower != ''">
              <div class="item">
                <img :src="datalist.data[0].data.lowerImage" alt />
                <p
                  class="font-12 color-gray2"
                  v-text="datalist.data[0].data.lower"
                >
                  超凡喜力5W-40全合成汽车润滑油
                </p>
              </div>
              <div class="item">
                <img :src="datalist.data[0].data.highImage" alt />
                <p class="font-12 color-gray2">
                  <span class="chiji font-10 flex">最佳</span>
                  {{ datalist.data[0].data.high }}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="other-commehernd" v-if="datalist.type != 'engineOil'">
          <header class="flex">
            <div class="title font-14">其他保养项目推荐</div>
          </header>
          <div class="content">
            <div
              class="item"
              v-for="(item, index) in datalist.data"
              :key="index"
            >
              <div class="preview flex last-no-bd">
                <div class="left flex">
                  <img
                    v-if="item.name == '主雨刮' || item.name == '副雨刮'"
                    src="@/assets/maintenance/yugua.png"
                    alt
                  />
                  <img
                    v-if="item.name == '火花塞'"
                    src="@/assets/maintenance/hhs.png"
                    alt
                  />
                  <img
                    v-if="item.name == '前刹车盘' || item.name == '后刹车盘'"
                    src="@/assets/maintenance/shachepan.png"
                    alt
                  />
                  <img
                    v-if="item.name == '前刹车片' || item.name == '后刹车片'"
                    src="@/assets/maintenance/shachepian.png"
                    alt
                  />
                  <img
                    v-if="item.name == '空气过滤器'"
                    src="@/assets/maintenance/kqglq.png"
                    alt
                  />
                  <img
                    v-if="item.name == '空调过滤器'"
                    src="@/assets/maintenance/ktglq.png"
                    alt
                  />
                  <img
                    v-if="item.name == '燃油过滤器'"
                    src="@/assets/maintenance/ryglq.png"
                    alt
                  />
                  <img
                    v-if="item.name == '机油过滤器'"
                    src="@/assets/maintenance/jyglq.png"
                    alt
                  />
                  <img
                    v-if="item.name == '蓄电池'"
                    src="@/assets/maintenance/xudianchi.png"
                    alt
                  />
                  <img
                    v-if="item.name == '皮带'"
                    src="@/assets/maintenance/pidai.png"
                    alt
                  />
                  <img
                    v-if="item.name == '车灯'"
                    src="@/assets/maintenance/chedeng.png"
                    alt
                  />
                  <img
                    v-if="item.name == '轮毂'"
                    src="@/assets/maintenance/longdong.png"
                    alt
                  />
                  <img
                    v-if="item.name == '轮胎'"
                    src="@/assets/maintenance/longtai.png"
                    alt
                  />
                  <div>
                    <p class="font-12 color-gray2" v-text="item.name">火花塞</p>
                    <p
                      class="describe font-10 color-gray9"
                      v-text="item.text"
                      v-if="item.text"
                    >
                      超凡喜力5W-40 全合成汽车润滑油
                    </p>
                  </div>
                </div>
                <i
                  class="iconfont icon-arrowB font-12"
                  v-bind:class="{ 'show-detail': item.isShowDetail }"
                ></i>
              </div>
              <div class="detail" :class="{ height0: !item.isShowDetail }">
                <div
                  class="detail-item flex"
                  v-for="(detail, index) in item.data"
                  v-show="item.isShowDetail"
                  :key="index"
                  v-zzz
                >
                  <div class="brand-item flex">
                    <div class="logo flex">
                      <img :src="detail.brandLogo" alt />
                      <div
                        class="brand font-12 color-gray2 flex"
                        v-text="detail.brandName"
                      >
                        电装
                      </div>
                    </div>
                    <div
                      class="flex type font-10 color-gray9"
                      v-text="
                        (detail.first ? detail.first : '') +
                        ' ' +
                        (detail.second ? detail.second : '') +
                        ' ' +
                        (detail.third ? detail.third : '')
                      "
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <!--<default-page v-show='loadData && data.length==0'></default-page>-->
  </div>
</template>

<script>
import api from "@/apis/maintenance-api";
export default {
  name: "maintenance-other-recommend",
  data() {
    return {
      datalist: false,
      loadData: false,
    };
  },
  created() {
    var self = this;
    if (self.$router.currentRoute.query.id) {
      self.id = self.$router.currentRoute.query.id;
      this.getData(self.id);
    }
  },
  methods: {
    //获得数据
    getData(id) {
      var self = this;
      var loading = self.$loading;
      loading.show("加载中...");
      api
        .upkeep({
          id: id,
        })
        .then((data) => {
          if (data.result_code == 0) {
            for (var i in data.response.data) {
              data.response.data[i].isShowDetail = false;
            }
            data.response.data[0].isShowDetail = true;
            self.datalist = data.response;
            self.loadData = true;
          } else {
            self.$toast.show({
              showTime: 2,
              message: data.message,
              style: "error",
            });
          }
          loading.hide();
          self.loadData = true;
        });
    },
    //显示详细
    showDetail(index) {
      if (this.datalist.data[index].isShowDetail == true) {
        for (var i in this.datalist.data) {
          this.datalist.data[i].isShowDetail = false;
        }
        return;
      }
      if (this.datalist.data[index].isShowDetail == false) {
        // eslint-disable-next-line no-redeclare
        for (var i in this.datalist.data) {
          this.datalist.data[i].isShowDetail = false;
        }
        this.datalist.data[index].isShowDetail = true;
      }
      // this.datalist.data[index].isShowDetail=!this.datalist.data[index].isShowDetail
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/page/maintenance/other-recommend.less";
</style>
